import { sharePage } from '@repo/common-utils';
import { useWorkingPlatform } from '@repo/platform';
import { useDialog } from '@repo/ui';
import { useToast } from '@zenterprise-inc/ui';

import { 경정청구서비스공유주소2 } from '@/lib/constants/link';

export const useInvalidOSDialog = () => {
  const toast = useToast();
  const { showDialog } = useDialog();
  const { workingPlatform } = useWorkingPlatform();

  const handleClickCopy = () => {
    sharePage(
      {
        title: '개인/법인사업자 환급금 무료 조회 - 비즈넵 세금 환급',
        url: 경정청구서비스공유주소2
      },
      () => {
        toast({ content: '링크를 복사했습니다.', icon: 'check-mark', iconColor: 'green.600' });
      }
    );
  };

  const showInvalidOSDialog = () => {
    showDialog({
      title: '윈도우 PC로 접속해주세요',
      description:
        workingPlatform === 'web'
          ? '공동인증서는 윈도우(Windows) PC에서만 사용할 수 있어요. 링크를 복사한 후 윈도우 PC에 접속해 이용해보세요.'
          : '공동인증서는 윈도우(Windows) PC에서만 사용할 수 있어요. 비즈넵 환급 웹사이트(https://bznav.com/tax/refund)를 통해 이용해주세요.',
      buttons: {
        primary: {
          text: '확인'
        },
        secondary:
          workingPlatform === 'web'
            ? {
                text: '접속 링크',
                onClick: handleClickCopy
              }
            : undefined
      }
    });
  };

  return { showInvalidOSDialog };
};
